import _ from 'lodash';
import React from 'react';
import { hitZoneCalc } from '../../utils/hitZoneCalc';
import { trackmanColorCode } from '../../utils/color/commonColor';

function HitCourseChart({size, data}) {
    let filterData = _.map(data, (item, idx) => {
        let hitPostion = JSON.parse(item['hitPostion']);
        item['hitCourseX'] = hitPostion['hitPositionX'];
        item['hitCourseY'] = hitPostion['hitPositionY'];
        return item;
    });

    let calcData = hitZoneCalc(size, filterData);

    return (
        <>
        <svg width={size+10} height={size+10}>
            <g transform='translate(5, 5)'>
                <image 
                href={`${process.env.PUBLIC_URL}/image/ground_green.jpeg`} 
                width={size} 
                height={size} />
                {calcData.map((item, idx) => (
                    item['x'] &&
                    <circle key={item['key']}
                    cx={item['x']}
                    cy={item['y']}
                    fill={trackmanColorCode(item['playResult'], item['pitchCall'])}
                    stroke={'black'}
                    r="3"
                    >
                    </circle>
                ))}
            </g>
        </svg>
        </>
    )
}

export default HitCourseChart;